module.exports = __webpack_public_path__ + "static/media/refresh.4aae07d7.png";